import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c3c382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData, (item, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (item.type === 'h4')
          ? (_openBlock(), _createBlock(_component_a_typography_title, {
              key: i,
              level: 4
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.content), 1)
              ]),
              _: 2
            }, 1024))
          : (item.type === 'h5')
            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                key: i,
                level: 5
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.content), 1)
                ]),
                _: 2
              }, 1024))
            : (item.type === 'p')
              ? (_openBlock(), _createBlock(_component_a_typography_paragraph, {
                  key: i,
                  content: item.content
                }, null, 8, ["content"]))
              : (item.type === 'list')
                ? (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: i }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (l, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'li' + i
                          }, _toDisplayString(l), 1))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : (item.type === 'image')
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      src: item.content,
                      key: i,
                      preview: false
                    }, null, 8, ["src"]))
                  : (item.type === 'video')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "videowrapper"
                      }, [
                        _createElementVNode("video", {
                          src: item.content,
                          autoplay: "",
                          controls: "controls"
                        }, null, 8, _hoisted_2)
                      ]))
                    : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}